document.addEventListener('DOMContentLoaded', () => {
  const selectEl = document.querySelector('.model-list__select');
  if (!selectEl) return;

  const currentBtn = selectEl.querySelector('.model-list__current');
  const popup = selectEl.querySelector('.model-list__popup');

  currentBtn.addEventListener('click', () => {
    selectEl.classList.toggle('model-list__select--open');
  });

  popup.addEventListener('click', (event) => {
    const btn = event.target.closest('.model-list__option');
    if (!btn) return;

    if (btn.hasAttribute('data-current')) {
      selectEl.classList.toggle('model-list__select--open');
      return;
    }

    window.location.href = btn.value;
  });
});
